export default __webpack_public_path__ + "static/media/privacy.d1b42d3d.md";